export default import.meta.ROLLUP_FILE_URL_CaAHi53g;